  function bundleproductcheckboxtoggle(checkbox) {
        var subProductsDiv = document.querySelector('.subproducts');
        var bundleProductsCheckboxlabeliddiv = document.getElementById('bundleProductsCheckboxlabelid');
        var bagsubproductdiv = document.getElementById('bagsubproduct');
        var topbagaddtocartcontainerdiv = document.querySelector('#topbagaddtocartcontainer');
        var bottombagaddtocartcontainerdiv = document.querySelector('#bottombagaddtocartcontainer');
        var bottombagaddtocartbuttondiv = document.getElementById('bottombagaddToCartButton');
        var topbagaddtocartbuttondiv = document.getElementById('topbagaddToCartButton');
        var baginputField = document.getElementById('properties[BAG NAME]');
        var baginputField2 = document.getElementById('properties[BAG NAME]2');
        var qtycheckboxcontainerdiv = document.getElementById('qtycheckboxcontainer');
        var bagquantitydisplaydiv = document.getElementById('bagquantity-display');
        var bagquantitydisplaydiv2 = document.getElementById('bagquantity-display2');
        var hidecheckboxiddiv2 = document.getElementById('hidecheckboxid2');
        var fancycheckboxdiv = document.querySelector('.fancy-checkbox');
    
        if (checkbox.checked) {
            subProductsDiv.style.maxHeight = "0";
            hidecheckboxiddiv2.style.display = "none";
            bagsubproductdiv.style.maxHeight = bagsubproductdiv.scrollHeight + "px";
            topbagaddtocartcontainerdiv.style.maxHeight = '0';
            topbagaddtocartbuttondiv.style.display = "none";
            qtycheckboxcontainerdiv.style.display = "none";
            bagquantitydisplaydiv.textContent = "0";
            bagquantitydisplaydiv2.textContent = "0";
            bundleProductsCheckboxlabeliddiv.textContent = "Bag Custom Name $13";
                        
        } else {

            hidecheckboxiddiv2.style.display = "";
            bagsubproductdiv.style.maxHeight = "0";
            topbagaddtocartcontainerdiv.style.maxHeight = "100%";
            topbagaddtocartbuttondiv.style.display = "";
            baginputField.value = '';
            baginputField2.value = '';
            qtycheckboxcontainerdiv.style.display = "";
            bagquantitydisplaydiv2.textContent = "0";
            bagquantitydisplaydiv.textContent = "0";
            bundleProductsCheckboxlabeliddiv.innerHTML = "CLICK HERE TO ADD CUSTOM NAME<br>FOR $13"; // Changed from textContent to innerHTML with span tags
            
        }
    }

